import FontAwesome from "../../../utils/FA";
import React from "react";
import {Link} from 'react-router';
import {duckify, dependentDuck, filterDuck, singleDuck} from "../../../utils/duckify";
import {paymentProfiles, users, customers} from "../../../ducks";
import {Tooltip, OverlayTrigger} from "react-bootstrap";
import {formattedDate} from "../../../utils/dateFormat";
import {formatCurrency} from "../../../utils/i18n";
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faMoneyBillAlt } from '@fortawesome/pro-solid-svg-icons/faMoneyBillAlt';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { AutopayDateDisplay } from '../../billing/AutopayDateEditor';

const BillingAccountOverview = ({allDucksReady, paymentProfiles, billingAccount, showMakePayment=false, customer}) => {
  return (
    !!allDucksReady && <div>
  <div className={'billing-account-overview row'}>
    <div className={'col-lg-18'}>
      <div className={'row'}>
        <div className={'billing-account-balance col-lg-24'}>
          <table>
            <tbody>
              <tr>
                <td>
                  Amount Due Today:
                </td>
                <td className={`billing-amount current ${billingAccount.overdue_at ? "error-text" : ""}`}>
                  { formatCurrency(Math.max(0, billingAccount.balance)) }
                </td>
                <td>
                  {billingAccount.overdue_at &&
                    <OverlayTrigger
                      placement={'bottom'}
                      overlay={<Tooltip>Your payment was due on {formattedDate(billingAccount.overdue_at)}</Tooltip>}
                    >
                      <span className={'billing-account-overdue error-text'}>
                        <FontAwesome icon={faExclamationTriangle} preNbsp postNbsp/>
                        Balance Overdue
                      </span>
                    </OverlayTrigger>
                  }
                </td>
              </tr>
              {billingAccount.balance < 0 && (
                <tr className={'billing-account-prepaid'}>
                  <td>
                    Prepaid Amount:
                  </td>
                  <td className={'billing-amount prepaid green'}>
                    {formatCurrency(billingAccount.balance)}
                  </td>
                  <td />
                </tr>
              )}
              <tr className={'billing-account-upcoming'}>
                <td className={'next-installment-label'}>
                  Next Installment:
                </td>
                <td className={'billing-amount upcoming'}>
                  { formatCurrency(billingAccount.upcoming_autopay_balance - billingAccount.balance) }
                </td>
                <td />
              </tr>
              <tr className={'billing-account-total'}>
                <td>
                  Total Due {formattedDate(billingAccount.upcoming_autopay_date)}:
                </td>
                <td className={'billing-amount'}>
                  { formatCurrency(Math.max(0, billingAccount.upcoming_autopay_balance)) }
                </td>
                <td />
              </tr>
            </tbody>
          </table>

          <div className='billing-account-autopay-days'>
            <AutopayDateDisplay showExpiringDays billingAccount={billingAccount} hideIcon daysCss='billing-amount' />
          </div>
          <div className='billing-account-autopay-days'>
            <AutopayDateDisplay billingAccount={billingAccount} hideIcon daysCss='billing-amount' />
          </div>
        </div>
      </div>

      {paymentProfiles && paymentProfiles.some(x=>!!x.autopay_enabled) &&
        <div className={'row billing-autopay-enabled'}>
          <div className={'col-lg-12'}>
            <FontAwesome icon={faCreditCard} nbsp/>
            AutoPay Enabled
            <OverlayTrigger placement={'right'}
                            overlay={<Tooltip>
                              Your account will be charged automatically on {formattedDate(billingAccount.next_date)}
                            </Tooltip>}
            >
              <FontAwesome icon={faInfoCircle} preNbsp/>
            </OverlayTrigger>
          </div>
        </div>
      }
    </div>

    {customer.allow_online_payments  &&<div className={'col-lg-6 text-end'}>
      {showMakePayment &&
        <Link to={`/portal/billing/accounts/${billingAccount.id}`} className={'btn btn-success'}>
          <FontAwesome icon={faMoneyBillAlt} nbsp/>
          Make Payment
        </Link>
      }
    </div>}
  </div>
</div>)}

const mapDucksToProps = (ownProps) => {
  const user = singleDuck(users, 'current');
  const customer = singleDuck(customers, 'current')

  return {
    user,
    customer,
    paymentProfiles: dependentDuck(user, ({value: currentUser}) =>
      filterDuck(paymentProfiles, {user_id: currentUser.id})
    )
  };
};

export default duckify(mapDucksToProps)(BillingAccountOverview);
